module.exports = __webpack_public_path__ + "static/radical-acceptance-858156100aade1174b66c525b4cecea2.jpg";